/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import ListSettings from "./files/ListSettings";
import {
  BannerWrapper,
  BioWrapper,
  BrandWrapper,
  CertificateWrapper,
  ChangePasswordWrapper,
  ChefTimingWrapper,
  ProfileUpdateWrapper,
  SoundUpdateWrapper,
} from "./files/BioWrapper";
import PasswordSuccess from "./files/PasswordSuccess";
import BannerSuccess from "./files/BannerSuccess";
import ProfileSuccess from "./files/ProfileSuccess";
import BioSuccess from "./files/BioSuccess";
import ProfilePicSuccess from "./files/ProfilePicSuccess";
import DeleteAccount from "./files/DeleteAccount";
import { AddCertificate } from "./files/AddCertificate";
import ListDishSubscription from "./files/listCompomponents/ListDishSubscription";
import NoAddressFound from "./files/listCompomponents/NoAddressFound";

const SettingsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="/list"
          element={
            <>
              <ListSettings />
            </>
          }
        />
        <Route
          path="/profile-details"
          element={
            <>
              <ProfileUpdateWrapper />
            </>
          }
        />
        <Route
          path="/profile-success"
          element={
            <>
              <ProfileSuccess />
            </>
          }
        />
        <Route
          path="/sound-update"
          element={
            <>
              <SoundUpdateWrapper />
            </>
          }
        />
        <Route
          path="/profile-success"
          element={
            <>
              <ProfilePicSuccess />
            </>
          }
        />
        <Route
          path="/change-timing"
          element={
            <>
              <ChefTimingWrapper />
            </>
          }
        />
        <Route
          path="/change-password"
          element={
            <>
              <ChangePasswordWrapper />
            </>
          }
        />
        <Route
          path="/password-success"
          element={
            <>
              <PasswordSuccess />
            </>
          }
        />
        <Route
          path="/delete-account"
          element={
            <>
              <DeleteAccount />
            </>
          }
        />
        <Route
          path="/bio-update"
          element={
            <>
              <BioWrapper />
            </>
          }
        />
        <Route
          path="/bio-success"
          element={
            <>
              <BioSuccess />
            </>
          }
        />
        <Route
          path="/brand-update"
          element={
            <>
              <BrandWrapper />
            </>
          }
        />
        <Route
          path="/brand-success"
          element={
            <>
              <BioSuccess />
            </>
          }
        />
        v
        <Route
          path="/change-banner"
          element={
            <>
              {/* <UpdateBanner /> */}
              <BannerWrapper />
            </>
          }
        />
        <Route
          path="/banner-success"
          element={
            <>
              <BannerSuccess />
            </>
          }
        />
        <Route
          path="/add-certificate"
          element={
            <>
              <AddCertificate />
            </>
          }
        />
        <Route
          path="/edit-certificate/:id"
          element={
            <>
              <CertificateWrapper />
            </>
          }
        />
        <Route
          path="/subscription-dish"
          element={
            <>
              <ListDishSubscription />
            </>
          }
        />
        <Route
          path="/no-address-found"
          element={
            <>
              <NoAddressFound />
            </>
          }
        />
        <Route index element={<Navigate to="list" />} />
      </Route>
    </Routes>
  );
};

export default SettingsPage;
